export default {
  user: {},
  token: "",
  role: "",
  guiche: "",
};
